import React from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";
// styles
import useStyles from "./styles";

// components
import PageError from '../PageError';
import PageLoading from '../PageLoading';
import { useQuery } from '@apollo/react-hooks';
import { GET_REPORT_BY_DATE } from "../../queries/reports";
import ImpressionsIndicator from "../Indicators/Impressions/impressions";
import RevenueIndicator from "../Indicators/Revenue/revenue";
import ViewabilityIndicator from "../Indicators/Viewability/viewability";
import PublisherChart from "../Charts/publisher";
import { ThemeProvider } from "@material-ui/styles";
import Themes from "../../themes";
import { formatImp, formatRevenue, momentFormat } from "../../components/Utils/formatters";
import { moment } from "../../components/Utils/momentConfig";

let mainChartData = [];
let impressionsTotal = 0;
let revenueTotal = 0;
let viewabilityTotal = 0;
let ctrTotal = 0;
let total = 0;
let totalActive = 0;

export default function GridByDay(props) {
  var { initialDate, endDate, publisherId, siteId, isDashboard, networkPublishers } = props;
  var classes = useStyles();

  if(isDashboard)
    siteId = "";

  function getHeaderLabel(index,column,sortColumn,value){
    return (
      <>
      <th className={classes.headerSum} onClick={() => sortColumn(index)} key={index}>
      {column.name} <br/> {value}
      </th>
      </>
    )
  }

  const { error: errorGeneral, loading: loadingGeneral, data } = useQuery(GET_REPORT_BY_DATE, {
    variables: { dateStart: moment(initialDate).format(momentFormat), dateEnd: moment(endDate).format(momentFormat), 
      publishers: [publisherId] },
  });

  if(data){
    mainChartData = data.reportByDate;
    impressionsTotal = 0;
    revenueTotal = 0;
    ctrTotal = 0;
    total = 0;
    totalActive = 0;
    mainChartData.forEach((row)=>{
      total++;
      if(row.impressions !== 0)
        totalActive++;
      impressionsTotal += parseFloat(row.impressions ? row.impressions : 0);
      revenueTotal += parseFloat(row.revenue ? row.revenue : 0);
      ctrTotal += parseFloat(row.ctr ? row.ctr : 0);
      viewabilityTotal += parseFloat(row.viewability ? row.revenue : 0);
    });
  }

  return (
    <>
    <ThemeProvider theme={Themes.defaultReports}>
    <Grid container spacing={4}>
      <RevenueIndicator publishers={[publisherId]} siteId={siteId}></RevenueIndicator>
      <ImpressionsIndicator publishers={[publisherId]} siteId={siteId} isDashboard={isDashboard}></ImpressionsIndicator>
      {(isDashboard !== true ?
      <ViewabilityIndicator publishers={[publisherId]} siteId={siteId}></ViewabilityIndicator> : <></>)}
      <br/>
      <PublisherChart initialDate={initialDate} endDate={endDate} networkPublishers={networkPublishers} isDashboard={isDashboard} ></PublisherChart>
      <Grid item xs={12}>
      {(loadingGeneral) ? <PageLoading /> : 
      (errorGeneral) ? <PageError /> :
      (
        <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title={false}
            data={mainChartData}
            columns={[
              {
                name    : 'date',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn)
                  },
                  customBodyRender: (value) => {
                    return (moment(value).add(1, 'days').format(momentFormat));
                  }
                }
              },
              {
                name    : 'ctr',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn, (ctrTotal/total).toFixed(2))
                  },
                  display : !isDashboard ? true : false
                }
              },
              {
                name    : 'cpm',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn, (revenueTotal/impressionsTotal).toFixed(2))
                  },
                  display : !isDashboard ? true : false
                }
              },
              {
                name    : 'impressions',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn, formatImp(impressionsTotal))
                  },
                  customBodyRender: (value) => {
                    return (formatImp(value));
                  }
                }
              },
              {
                name    : 'revenue',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn, formatRevenue.format(revenueTotal))
                  },
                  customBodyRender: (value) => {
                    return (`$${formatImp(value)}`);
                  }
                }
              },
              {
                name    : 'viewability',
                options: {
                  customHeadRender: ({index, ...column}, sortColumn) => {
                    return getHeaderLabel(index,column,sortColumn, (viewabilityTotal/totalActive).toFixed(2))
                  },
                  customBodyRender: (value) => {
                    const floatValue = parseFloat(value);
                    return (floatValue >= 80 ? <div style={{backgroundColor: "#dff0d8", fontWeight: "bold"}}>{value}</div> : 
                    floatValue >= 60 && floatValue < 80 ? <div style={{backgroundColor: "#fcf8e3", fontWeight: "bold"}}>{value}</div>:
                    floatValue < 60 ? <div style={{backgroundColor: "#f2dede", fontWeight: "bold"}}>{value}</div> : <div>{value}</div>);
                  },
                  display : !isDashboard ? true : false
                }
              }              
            ]}
            options={{
              customToolbarSelect: () => {},
              rowsPerPage: 100,
              selectableRows: 'none'
            }}
          />
        </Grid>
      </Grid>
      )}
      </Grid>
    </Grid>
    </ThemeProvider>
    </>
  );
}